export default __webpack_public_path__ + "static/media/stainless2.f26a9c02.jpg";